var Kowloon = "Kowloon";
var HKStates = {
	"Hong Kong Island": "Hong Kong Island",
	Kowloon: Kowloon,
	"Lantau Island": "Lantau Island",
	"New Territories": "New Territories"
};

export { Kowloon, HKStates as default };
